import { SET_CLINICS_SUCCESS } from "./clinics.types";

export const setClinics = (clinics) => async (dispatch) => {
    dispatch({
        type: SET_CLINICS_SUCCESS,
        payload: { clinics },
    });
};
